export * from "/codebuild/output/src229471894/src/dgbet/local_modules/wallet/index.ts"